var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _g, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEggBox6Eggs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 112,
    viewBox: "0 0 161 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.73877 81.5088L11.7036 69.823L20.3468 69.823L16.5 82.3131L0.73877 81.5088Z",
    fill: "#FCEBDB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M160.511 81.5088L149.545 69.823H139.5V82.3131L160.511 81.5088Z",
    fill: "#FCEBDB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M150.57 5.10392C147.44 1.9738 143.278 0.25 138.852 0.25H21.2232C16.7964 0.25 12.6349 1.9738 9.50479 5.10392C6.37468 8.23403 4.65088 12.3959 4.65088 16.8223V54.9664C4.65088 59.3931 6.37468 63.5546 9.50479 66.6848C12.6349 69.8149 16.7968 71.5387 21.2232 71.5387H138.852C143.279 71.5387 147.44 69.8149 150.57 66.6848C153.7 63.5546 155.424 59.3928 155.424 54.9664V16.8227C155.424 12.3959 153.7 8.2344 150.57 5.10392ZM44.6029 11.3593C44.6029 11.9261 44.139 12.3903 43.5718 12.3903H30.4446C29.8777 12.3903 29.4135 11.9265 29.4135 11.3593C29.4135 10.7925 29.8774 10.3283 30.4446 10.3283H43.5722C44.139 10.3283 44.6029 10.7925 44.6029 11.3593ZM131.836 11.3593C131.836 11.9261 131.372 12.3903 130.805 12.3903H117.678C117.111 12.3903 116.647 11.9265 116.647 11.3593C116.647 10.7925 117.11 10.3283 117.678 10.3283H130.805C131.372 10.3283 131.836 10.7925 131.836 11.3593Z",
    fill: "url(#paint0_linear_10258_11880)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M149.025 6.64965C146.308 3.93225 142.695 2.43591 138.852 2.43591H21.2234C17.3805 2.43591 13.7677 3.93225 11.0507 6.64965C8.33325 9.36706 6.83691 12.9799 6.83691 16.8224V54.9665C6.83691 58.8094 8.33325 62.4222 11.0507 65.1393C13.7681 67.8567 17.3809 69.353 21.2234 69.353H138.852C142.695 69.353 146.308 67.8567 149.025 65.1393C151.742 62.4219 153.239 58.809 153.239 54.9665V16.8228C153.239 12.9799 151.742 9.36706 149.025 6.64965ZM44.6031 11.3595C44.6031 11.9263 44.1393 12.3905 43.5721 12.3905H30.4448C29.878 12.3905 29.4138 11.9266 29.4138 11.3595C29.4138 10.7926 29.8776 10.3284 30.4448 10.3284H43.5725C44.1393 10.3284 44.6031 10.7926 44.6031 11.3595ZM131.837 11.3595C131.837 11.9263 131.373 12.3905 130.805 12.3905H117.678C117.111 12.3905 116.647 11.9266 116.647 11.3595C116.647 10.7926 117.111 10.3284 117.678 10.3284H130.805C131.373 10.3284 131.837 10.7926 131.837 11.3595Z",
    fill: "url(#paint1_linear_10258_11880)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M142.715 12.9594C141.668 11.9125 140.332 11.3594 138.852 11.3594H131.836C131.836 11.9262 131.372 12.3904 130.805 12.3904H117.677C117.11 12.3904 116.646 11.9266 116.646 11.3594H44.6029C44.6029 11.9262 44.1391 12.3904 43.5719 12.3904H30.4446C29.8778 12.3904 29.4136 11.9266 29.4136 11.3594H21.2232C19.7428 11.3594 18.4069 11.9129 17.3603 12.9594C16.3134 14.0064 15.7603 15.3419 15.7603 16.8227V54.9668C15.7603 56.4472 16.3137 57.7831 17.3603 58.8301C18.4073 59.877 19.7428 60.4302 21.2232 60.4302H138.852C140.332 60.4302 141.668 59.8767 142.715 58.8301C143.762 57.7831 144.315 56.4472 144.315 54.9668V16.8227C144.315 15.3423 143.762 14.0064 142.715 12.9594Z",
    fill: "#E9D9C8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M29.9133 83.7007C37.7495 83.7007 44.102 75.2569 44.102 64.8408C44.102 54.4247 37.7495 45.9808 29.9133 45.9808C22.0771 45.9808 15.7246 54.4247 15.7246 64.8408C15.7246 75.2569 22.0771 83.7007 29.9133 83.7007Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M64.3244 83.7007C72.1606 83.7007 78.5131 75.2569 78.5131 64.8408C78.5131 54.4247 72.1606 45.9808 64.3244 45.9808C56.4882 45.9808 50.1357 54.4247 50.1357 64.8408C50.1357 75.2569 56.4882 83.7007 64.3244 83.7007Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M98.7361 83.7007C106.572 83.7007 112.925 75.2569 112.925 64.8408C112.925 54.4247 106.572 45.9808 98.7361 45.9808C90.8999 45.9808 84.5474 54.4247 84.5474 64.8408C84.5474 75.2569 90.8999 83.7007 98.7361 83.7007Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M133.148 83.7007C140.984 83.7007 147.336 75.2569 147.336 64.8408C147.336 54.4247 140.984 45.9808 133.148 45.9808C125.311 45.9808 118.959 54.4247 118.959 64.8408C118.959 75.2569 125.311 83.7007 133.148 83.7007Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4968 79.6349C17.5183 91.4945 24.0382 101.099 32.0781 101.099C40.1181 101.099 46.638 91.4945 46.6595 79.6349H17.4968Z",
    fill: "#AA9D93"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3792 97.366V102.032C24.3792 102.683 27.826 103.211 32.0783 103.211C36.3306 103.211 39.7774 102.683 39.7774 102.032V97.366H24.3792Z",
    fill: "#AA9D93"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8616 79.635C49.8831 91.4945 56.403 101.099 64.443 101.099C72.4829 101.099 79.0028 91.4945 79.0243 79.635H49.8616Z",
    fill: "#AA9D93"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7439 97.366V102.032C56.7439 102.683 60.1908 103.211 64.443 103.211C68.6949 103.211 72.1422 102.683 72.1422 102.032V97.366H56.7439Z",
    fill: "#AA9D93"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2258 79.635C82.2473 91.4945 88.7672 101.099 96.8072 101.099C104.847 101.099 111.367 91.4945 111.389 79.635H82.2258Z",
    fill: "#AA9D93"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1081 97.366V102.032C89.1081 102.683 92.555 103.211 96.8072 103.211C101.059 103.211 104.506 102.683 104.506 102.032V97.366H89.1081Z",
    fill: "#AA9D93"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M114.591 79.635C114.612 91.4945 121.132 101.099 129.172 101.099C137.212 101.099 143.732 91.4945 143.753 79.635H114.591Z",
    fill: "#AA9D93"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M121.473 97.366V102.032C121.473 102.683 124.92 103.211 129.172 103.211C133.424 103.211 136.871 102.683 136.871 102.032V97.366H121.473Z",
    fill: "#AA9D93"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8052 48C39.384 47.9765 46.0591 65.2931 43.4245 76.2685C41.0937 85.9871 34.3985 88 29.039 88C23.6795 88 17.1713 85.3855 14.6535 76.6449C11.7417 66.5231 18.9344 48.0235 28.8052 48Z",
    fill: "#ED9449"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7342 56.2401C19.4653 58.28 18.1863 60.8474 17.9125 62.988C17.4116 66.9299 20.2934 67.3735 21.2985 65.4176C22.3036 63.4618 23.3321 61.4825 24.965 58.858C27.2223 55.232 30.9189 52.8023 29.1023 51.2263C27.2858 49.6502 23.3989 51.9521 20.7342 56.2401Z",
    fill: "#EEAA4F"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1451 61.8218C38.5176 61.8218 38.8196 61.5119 38.8196 61.1296C38.8196 60.7472 38.5176 60.4373 38.1451 60.4373C37.7726 60.4373 37.4706 60.7472 37.4706 61.1296C37.4706 61.5119 37.7726 61.8218 38.1451 61.8218Z",
    fill: "#D47858"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9036 78.371C39.0573 77.9951 38.8804 77.5656 38.5086 77.4117C38.1368 77.2578 37.7108 77.4378 37.5572 77.8137C37.4035 78.1896 37.5804 78.6191 37.9522 78.773C38.324 78.9269 38.75 78.7469 38.9036 78.371Z",
    fill: "#D47858"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2429 81.3167C19.386 80.9665 19.22 80.5659 18.8721 80.4219C18.5241 80.2778 18.1261 80.445 17.9829 80.7951C17.8398 81.1453 18.0059 81.5459 18.3538 81.6899C18.7018 81.8339 19.0998 81.6668 19.2429 81.3167Z",
    fill: "#D47858"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6474 68.3149C41.1501 68.0528 41.3718 67.4796 41.1427 67.0346C40.9137 66.5897 40.3204 66.4416 39.8177 66.7037C39.315 66.9659 39.0933 67.5391 39.3223 67.984C39.5514 68.4289 40.1447 68.5771 40.6474 68.3149Z",
    fill: "#D47858"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9203 77.3354C31.4229 77.0732 31.6447 76.5 31.4156 76.0551C31.1865 75.6102 30.5933 75.462 30.0906 75.7242C29.5879 75.9863 29.3661 76.5595 29.5952 77.0044C29.8243 77.4494 30.4176 77.5975 30.9203 77.3354Z",
    fill: "#D47858"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M29.965 82.1086C30.3364 81.6399 30.3219 81.0067 29.9326 80.6942C29.5433 80.3818 28.9266 80.5085 28.5552 80.9771C28.1838 81.4458 28.1983 82.079 28.5876 82.3915C28.9769 82.7039 29.5936 82.5773 29.965 82.1086Z",
    fill: "#D47858"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9822 83.2193C26.4209 82.7227 26.39 81.9743 25.9132 81.5476C25.4363 81.1209 24.6941 81.1775 24.2554 81.674C23.8167 82.1705 23.8476 82.9189 24.3244 83.3456C24.8012 83.7724 25.5435 83.7158 25.9822 83.2193Z",
    fill: "#D47858"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8052 48C73.384 47.9765 80.0591 65.2931 77.4245 76.2685C75.0937 85.9871 68.3985 88 63.039 88C57.6795 88 51.1713 85.3855 48.6535 76.6449C45.7417 66.5231 52.9344 48.0235 62.8052 48Z",
    fill: "#ED9449"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7342 56.2401C53.4653 58.28 52.1863 60.8474 51.9125 62.988C51.4116 66.9299 54.2934 67.3735 55.2985 65.4176C56.3036 63.4618 57.3321 61.4825 58.965 58.858C61.2223 55.232 64.9189 52.8023 63.1023 51.2263C61.2858 49.6502 57.3989 51.9521 54.7342 56.2401Z",
    fill: "#EEAA4F"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1451 61.8218C72.5176 61.8218 72.8196 61.5119 72.8196 61.1296C72.8196 60.7472 72.5176 60.4373 72.1451 60.4373C71.7726 60.4373 71.4706 60.7472 71.4706 61.1296C71.4706 61.5119 71.7726 61.8218 72.1451 61.8218Z",
    fill: "#D47858"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9036 78.371C73.0573 77.9951 72.8804 77.5656 72.5086 77.4117C72.1368 77.2578 71.7108 77.4378 71.5572 77.8137C71.4035 78.1896 71.5804 78.6191 71.9522 78.773C72.324 78.9269 72.75 78.7469 72.9036 78.371Z",
    fill: "#D47858"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2429 81.3167C53.386 80.9665 53.22 80.5659 52.8721 80.4219C52.5241 80.2778 52.1261 80.445 51.9829 80.7951C51.8398 81.1453 52.0059 81.5459 52.3538 81.6899C52.7018 81.8339 53.0998 81.6668 53.2429 81.3167Z",
    fill: "#D47858"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6474 68.3149C75.1501 68.0528 75.3718 67.4796 75.1427 67.0346C74.9137 66.5897 74.3204 66.4416 73.8177 66.7037C73.315 66.9659 73.0933 67.5391 73.3223 67.984C73.5514 68.4289 74.1447 68.5771 74.6474 68.3149Z",
    fill: "#D47858"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9203 77.3354C65.4229 77.0732 65.6447 76.5 65.4156 76.0551C65.1865 75.6102 64.5933 75.462 64.0906 75.7242C63.5879 75.9863 63.3661 76.5595 63.5952 77.0044C63.8243 77.4494 64.4176 77.5975 64.9203 77.3354Z",
    fill: "#D47858"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M63.965 82.1086C64.3364 81.6399 64.3219 81.0067 63.9326 80.6942C63.5433 80.3818 62.9266 80.5085 62.5552 80.9771C62.1838 81.4458 62.1983 82.079 62.5876 82.3915C62.9769 82.7039 63.5936 82.5773 63.965 82.1086Z",
    fill: "#D47858"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9822 83.2193C60.4209 82.7227 60.39 81.9743 59.9132 81.5476C59.4363 81.1209 58.6941 81.1775 58.2554 81.674C57.8167 82.1705 57.8476 82.9189 58.3244 83.3456C58.8012 83.7724 59.5435 83.7158 59.9822 83.2193Z",
    fill: "#D47858"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8052 48C107.384 47.9765 114.059 65.2931 111.424 76.2685C109.094 85.9871 102.398 88 97.039 88C91.6795 88 85.1713 85.3855 82.6535 76.6449C79.7417 66.5231 86.9344 48.0235 96.8052 48Z",
    fill: "#ED9449"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M88.7342 56.2401C87.4653 58.28 86.1863 60.8474 85.9125 62.988C85.4116 66.9299 88.2934 67.3735 89.2985 65.4176C90.3036 63.4618 91.3321 61.4825 92.965 58.858C95.2223 55.232 98.9189 52.8023 97.1023 51.2263C95.2858 49.6502 91.3989 51.9521 88.7342 56.2401Z",
    fill: "#EEAA4F"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M106.145 61.8218C106.518 61.8218 106.82 61.5119 106.82 61.1296C106.82 60.7472 106.518 60.4373 106.145 60.4373C105.773 60.4373 105.471 60.7472 105.471 61.1296C105.471 61.5119 105.773 61.8218 106.145 61.8218Z",
    fill: "#D47858"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M106.904 78.371C107.057 77.9951 106.88 77.5656 106.509 77.4117C106.137 77.2578 105.711 77.4378 105.557 77.8137C105.404 78.1896 105.58 78.6191 105.952 78.773C106.324 78.9269 106.75 78.7469 106.904 78.371Z",
    fill: "#D47858"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2429 81.3167C87.386 80.9665 87.22 80.5659 86.8721 80.4219C86.5241 80.2778 86.1261 80.445 85.9829 80.7951C85.8398 81.1453 86.0059 81.5459 86.3538 81.6899C86.7018 81.8339 87.0998 81.6668 87.2429 81.3167Z",
    fill: "#D47858"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M108.647 68.3149C109.15 68.0528 109.372 67.4796 109.143 67.0346C108.914 66.5897 108.32 66.4416 107.818 66.7037C107.315 66.9659 107.093 67.5391 107.322 67.984C107.551 68.4289 108.145 68.5771 108.647 68.3149Z",
    fill: "#D47858"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9203 77.3354C99.4229 77.0732 99.6447 76.5 99.4156 76.0551C99.1865 75.6102 98.5933 75.462 98.0906 75.7242C97.5879 75.9863 97.3661 76.5595 97.5952 77.0044C97.8243 77.4494 98.4176 77.5975 98.9203 77.3354Z",
    fill: "#D47858"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M97.965 82.1086C98.3364 81.6399 98.3219 81.0067 97.9326 80.6942C97.5433 80.3818 96.9266 80.5085 96.5552 80.9771C96.1838 81.4458 96.1983 82.079 96.5876 82.3915C96.9769 82.7039 97.5936 82.5773 97.965 82.1086Z",
    fill: "#D47858"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M93.9822 83.2193C94.4209 82.7227 94.39 81.9743 93.9132 81.5476C93.4363 81.1209 92.6941 81.1775 92.2554 81.674C91.8167 82.1705 91.8476 82.9189 92.3244 83.3456C92.8012 83.7724 93.5435 83.7158 93.9822 83.2193Z",
    fill: "#D47858"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M130.805 48C141.384 47.9765 148.059 65.2931 145.424 76.2685C143.094 85.9871 136.398 88 131.039 88C125.679 88 119.171 85.3855 116.654 76.6449C113.742 66.5231 120.934 48.0235 130.805 48Z",
    fill: "#ED9449"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M122.734 56.2401C121.465 58.28 120.186 60.8474 119.913 62.988C119.412 66.9299 122.293 67.3735 123.299 65.4176C124.304 63.4618 125.332 61.4825 126.965 58.858C129.222 55.232 132.919 52.8023 131.102 51.2263C129.286 49.6502 125.399 51.9521 122.734 56.2401Z",
    fill: "#EEAA4F"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M140.145 61.8218C140.518 61.8218 140.82 61.5119 140.82 61.1296C140.82 60.7472 140.518 60.4373 140.145 60.4373C139.773 60.4373 139.471 60.7472 139.471 61.1296C139.471 61.5119 139.773 61.8218 140.145 61.8218Z",
    fill: "#D47858"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M140.904 78.371C141.057 77.9951 140.88 77.5656 140.509 77.4117C140.137 77.2578 139.711 77.4378 139.557 77.8137C139.404 78.1896 139.58 78.6191 139.952 78.773C140.324 78.9269 140.75 78.7469 140.904 78.371Z",
    fill: "#D47858"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M121.243 81.3167C121.386 80.9665 121.22 80.5659 120.872 80.4219C120.524 80.2778 120.126 80.445 119.983 80.7951C119.84 81.1453 120.006 81.5459 120.354 81.6899C120.702 81.8339 121.1 81.6668 121.243 81.3167Z",
    fill: "#D47858"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M142.647 68.3149C143.15 68.0528 143.372 67.4796 143.143 67.0346C142.914 66.5897 142.32 66.4416 141.818 66.7037C141.315 66.9659 141.093 67.5391 141.322 67.984C141.551 68.4289 142.145 68.5771 142.647 68.3149Z",
    fill: "#D47858"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M132.92 77.3354C133.423 77.0732 133.645 76.5 133.416 76.0551C133.187 75.6102 132.593 75.462 132.091 75.7242C131.588 75.9863 131.366 76.5595 131.595 77.0044C131.824 77.4494 132.418 77.5975 132.92 77.3354Z",
    fill: "#D47858"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M131.965 82.1086C132.336 81.6399 132.322 81.0067 131.933 80.6942C131.543 80.3818 130.927 80.5085 130.555 80.9771C130.184 81.4458 130.198 82.079 130.588 82.3915C130.977 82.7039 131.594 82.5773 131.965 82.1086Z",
    fill: "#D47858"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M127.982 83.2193C128.421 82.7227 128.39 81.9743 127.913 81.5476C127.436 81.1209 126.694 81.1775 126.255 81.674C125.817 82.1705 125.848 82.9189 126.324 83.3456C126.801 83.7724 127.543 83.7158 127.982 83.2193Z",
    fill: "#D47858"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.09
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.0003 75.6351C42.0003 75.6814 42.0003 75.728 41.9995 75.774C41.9032 75.9348 41.8039 76.093 41.7039 76.2493C39.038 80.3923 35.0765 83.0185 30.6535 83.0185C22.6265 83.0185 16.1191 74.3688 16.1191 63.6981C16.1191 62.1477 16.2566 60.6395 16.5163 59.195C19.1959 56.3857 22.5794 54.7094 26.2575 54.7094C34.9517 54.7086 42.0003 64.0778 42.0003 75.6351Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4393 96.5619C71.1343 96.5619 78.1829 87.1926 78.1829 75.6351C78.1829 64.0775 71.1343 54.7083 62.4393 54.7083C53.7444 54.7083 46.6958 64.0775 46.6958 75.6351C46.6958 87.1926 53.7444 96.5619 62.4393 96.5619Z",
    fill: "black"
  }))), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M149.591 83.1309H13.1185V92.4238H149.591V83.1309Z",
    fill: "#AA9D93"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M40.396 59.3608L43.1215 60.2989V82.981H33.1377L40.396 59.3608Z",
    fill: "#E0C7AC"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8471 59.3609L43.1215 60.2989V82.981H53.1054L45.8471 59.3609Z",
    fill: "#CBB39E"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3958 59.3609L43.1214 58.3058L45.8469 59.3609L43.1214 60.2989L40.3958 59.3609Z",
    fill: "#FFEAD7"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8994 59.3608L80.6249 60.2989V82.981H70.6411L77.8994 59.3608Z",
    fill: "#E0C7AC"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3504 59.3609L80.6248 60.2989V82.981H90.6086L83.3504 59.3609Z",
    fill: "#CBB39E"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8992 59.3609L80.6248 58.3058L83.3504 59.3609L80.6248 60.2989L77.8992 59.3609Z",
    fill: "#FFEAD7"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M115.403 59.3608L118.128 60.2989V82.981H108.145L115.403 59.3608Z",
    fill: "#E0C7AC"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M120.854 59.3609L118.128 60.2989V82.981H128.112L120.854 59.3609Z",
    fill: "#CBB39E"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M115.403 59.3609L118.128 58.3058L120.854 59.3609L118.128 60.2989L115.403 59.3609Z",
    fill: "#FFEAD7"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1276 59C34.9367 58.9761 41.7572 76.5796 39.0652 87.7367C36.6836 97.6162 29.8427 99.6625 24.3665 99.6625C18.8903 99.6625 12.2404 97.0047 9.66775 88.1193C6.69252 77.8299 14.0419 59.0239 24.1276 59Z",
    fill: "#F2A05B"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8808 67.3766C14.5843 69.4502 13.2775 72.0602 12.9977 74.2362C12.4859 78.2434 15.4304 78.6943 16.4574 76.7061C17.4844 74.7179 18.5353 72.7058 20.2038 70.0378C22.5103 66.3518 26.2873 63.8819 24.4312 62.2797C22.5751 60.6775 18.6036 63.0176 15.8808 67.3766Z",
    fill: "#FECC88"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6709 73.0508C34.0515 73.0508 34.3601 72.7357 34.3601 72.347C34.3601 71.9584 34.0515 71.6433 33.6709 71.6433C33.2903 71.6433 32.9817 71.9584 32.9817 72.347C32.9817 72.7357 33.2903 73.0508 33.6709 73.0508Z",
    fill: "#D47858"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4459 89.8741C34.6029 89.4919 34.4222 89.0553 34.0423 88.8989C33.6623 88.7424 33.2271 88.9254 33.0701 89.3075C32.9131 89.6896 33.0939 90.1262 33.4738 90.2827C33.8537 90.4391 34.2889 90.2562 34.4459 89.8741Z",
    fill: "#D47858"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3571 92.8685C14.5034 92.5125 14.3337 92.1053 13.9782 91.9589C13.6227 91.8125 13.2159 91.9823 13.0697 92.3383C12.9235 92.6942 13.0931 93.1015 13.4486 93.2479C13.8042 93.3943 14.2109 93.2244 14.3571 92.8685Z",
    fill: "#D47858"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2277 79.6514C36.7413 79.3849 36.9679 78.8022 36.7338 78.3499C36.4998 77.8976 35.8936 77.747 35.38 78.0135C34.8663 78.28 34.6397 78.8627 34.8738 79.315C35.1079 79.7673 35.714 79.9179 36.2277 79.6514Z",
    fill: "#D47858"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2887 88.8213C26.8023 88.5548 27.029 87.9721 26.7949 87.5198C26.5608 87.0675 25.9546 86.9169 25.441 87.1834C24.9274 87.4499 24.7008 88.0326 24.9348 88.4848C25.1689 88.9371 25.7751 89.0877 26.2887 88.8213Z",
    fill: "#D47858"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3126 93.6735C25.6921 93.1971 25.6773 92.5534 25.2795 92.2357C24.8817 91.9181 24.2516 92.0469 23.8721 92.5233C23.4926 92.9998 23.5075 93.6435 23.9052 93.9611C24.303 94.2787 24.9331 94.15 25.3126 93.6735Z",
    fill: "#D47858"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2431 94.8026C21.6913 94.2978 21.6598 93.537 21.1725 93.1032C20.6853 92.6694 19.9269 92.727 19.4787 93.2317C19.0304 93.7365 19.062 94.4973 19.5492 94.9311C20.0364 95.3649 20.7948 95.3073 21.2431 94.8026Z",
    fill: "#D47858"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1276 59C72.9367 58.9761 79.7572 76.5796 77.0652 87.7367C74.6836 97.6162 67.8427 99.6625 62.3665 99.6625C56.8903 99.6625 50.2404 97.0047 47.6677 88.1193C44.6925 77.8299 52.0419 59.0239 62.1276 59Z",
    fill: "#F2A05B"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8808 67.3766C52.5843 69.4502 51.2775 72.0602 50.9977 74.2362C50.4859 78.2434 53.4304 78.6943 54.4574 76.7061C55.4844 74.7179 56.5353 72.7058 58.2038 70.0378C60.5103 66.3518 64.2873 63.8819 62.4312 62.2797C60.5751 60.6775 56.6036 63.0176 53.8808 67.3766Z",
    fill: "#FECC88"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6709 73.0508C72.0515 73.0508 72.3601 72.7357 72.3601 72.347C72.3601 71.9584 72.0515 71.6433 71.6709 71.6433C71.2903 71.6433 70.9817 71.9584 70.9817 72.347C70.9817 72.7357 71.2903 73.0508 71.6709 73.0508Z",
    fill: "#D47858"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4459 89.8741C72.6029 89.4919 72.4222 89.0553 72.0423 88.8989C71.6623 88.7424 71.2271 88.9254 71.0701 89.3075C70.9131 89.6896 71.0939 90.1262 71.4738 90.2827C71.8537 90.4391 72.2889 90.2562 72.4459 89.8741Z",
    fill: "#D47858"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3571 92.8685C52.5034 92.5125 52.3337 92.1053 51.9782 91.9589C51.6227 91.8125 51.2159 91.9823 51.0697 92.3383C50.9235 92.6942 51.0931 93.1015 51.4486 93.2479C51.8042 93.3943 52.2109 93.2244 52.3571 92.8685Z",
    fill: "#D47858"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2277 79.6514C74.7413 79.3849 74.9679 78.8022 74.7338 78.3499C74.4998 77.8976 73.8936 77.747 73.38 78.0135C72.8663 78.28 72.6397 78.8627 72.8738 79.315C73.1079 79.7673 73.714 79.9179 74.2277 79.6514Z",
    fill: "#D47858"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2887 88.8213C64.8023 88.5548 65.029 87.9721 64.7949 87.5198C64.5608 87.0675 63.9546 86.9169 63.441 87.1834C62.9274 87.4499 62.7008 88.0326 62.9348 88.4848C63.1689 88.9371 63.7751 89.0877 64.2887 88.8213Z",
    fill: "#D47858"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3126 93.6735C63.6921 93.1971 63.6773 92.5534 63.2795 92.2357C62.8817 91.9181 62.2516 92.0469 61.8721 92.5233C61.4926 92.9998 61.5075 93.6435 61.9052 93.9611C62.303 94.2787 62.9331 94.15 63.3126 93.6735Z",
    fill: "#D47858"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2431 94.8026C59.6913 94.2978 59.6598 93.537 59.1725 93.1032C58.6853 92.6694 57.9269 92.727 57.4787 93.2317C57.0304 93.7365 57.062 94.4973 57.5492 94.9311C58.0364 95.3649 58.7948 95.3073 59.2431 94.8026Z",
    fill: "#D47858"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M6.02637 82.9812C6.05156 96.9958 13.7562 108.346 23.257 108.346C32.7577 108.346 40.4624 96.9958 40.4876 82.9812H6.02637Z",
    fill: "url(#paint2_radial_10258_11880)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M14 104V110.387C14 111.278 18.0294 112 23 112C27.9706 112 32 111.278 32 110.387V104H14Z",
    fill: "url(#paint3_linear_10258_11880)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2715 82.9812C44.2967 96.9958 52.0014 108.346 61.5021 108.346C71.0028 108.346 78.7075 96.9958 78.7327 82.9812H44.2715Z",
    fill: "url(#paint4_radial_10258_11880)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M52 104V110.387C52 111.278 56.2533 112 61.5 112C66.7467 112 71 111.278 71 110.387V104H52Z",
    fill: "url(#paint5_linear_10258_11880)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5171 82.9812C82.5423 96.9958 90.247 108.346 99.7477 108.346C109.248 108.346 116.953 96.9958 116.978 82.9812H82.5171Z",
    fill: "url(#paint6_radial_10258_11880)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M91 104V110.387C91 111.278 95.0294 112 100 112C104.971 112 109 111.278 109 110.387V104H91Z",
    fill: "url(#paint7_linear_10258_11880)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M120.762 82.9812C120.787 96.9958 128.492 108.346 137.993 108.346C147.494 108.346 155.198 96.9958 155.223 82.9812H120.762Z",
    fill: "url(#paint8_radial_10258_11880)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M129 104V110.387C129 111.278 133.029 112 138 112C142.971 112 147 111.278 147 110.387V104H129Z",
    fill: "url(#paint9_linear_10258_11880)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M40.488 82.9812H6.02637C6.0297 84.7617 6.15714 86.4988 6.39647 88.1756H40.1182C40.3572 86.4988 40.4846 84.7617 40.488 82.9812Z",
    fill: "black"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M78.7331 82.9812H44.2715C44.2748 84.7617 44.4023 86.4988 44.6416 88.1756H78.3634C78.6023 86.4988 78.7301 84.7617 78.7331 82.9812Z",
    fill: "black"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M116.979 82.9812H82.5171C82.5204 84.7617 82.6479 86.4988 82.8872 88.1756H116.609C116.848 86.4988 116.975 84.7617 116.979 82.9812Z",
    fill: "black"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M155.224 82.9812H120.762C120.766 84.7617 120.893 86.4988 121.132 88.1756H154.854C155.093 86.4988 155.22 84.7617 155.224 82.9812Z",
    fill: "black"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M0.738892 81.5089V82.2469C0.738892 83.4654 1.72657 84.4531 2.94505 84.4531H158.305C159.524 84.4531 160.511 83.4654 160.511 82.2469V81.5089H0.738892Z",
    fill: "#F4E7D9"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0083 72.8969C33.071 72.8969 29.8738 76.4386 29.8245 80.8287H44.1925C44.1429 76.4386 40.9457 72.8969 37.0083 72.8969Z",
    fill: "#FCEBDB"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0083 73.5745C33.0709 73.5745 29.8737 77.1162 29.8245 81.5063H44.1924C44.1428 77.1162 40.9456 73.5745 37.0083 73.5745Z",
    fill: "url(#paint10_linear_10258_11880)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M29.9104 80.3612C29.8582 80.735 29.8285 81.1173 29.8245 81.5063H44.1924C44.188 81.1173 44.1584 80.735 44.1065 80.3612H29.9104Z",
    fill: "black"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M124.242 72.8969C120.304 72.8969 117.107 76.4386 117.058 80.8287H131.426C131.376 76.4386 128.179 72.8969 124.242 72.8969Z",
    fill: "#FCEBDB"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M124.242 73.5746C120.304 73.5746 117.107 77.1163 117.058 81.5064H131.426C131.376 77.1163 128.179 73.5746 124.242 73.5746Z",
    fill: "url(#paint11_linear_10258_11880)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M117.144 80.3612C117.092 80.735 117.062 81.1174 117.058 81.5064H131.426C131.421 81.1174 131.392 80.735 131.34 80.3612H117.144Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10258_11880",
    x1: 80.0374,
    y1: 0.454641,
    x2: 80.0374,
    y2: 75.2917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9D9C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7D5C2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10258_11880",
    x1: 80.0377,
    y1: 2.9007,
    x2: 80.0377,
    y2: 66.921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B49D8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6D6C5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_10258_11880",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.2572 95.6632) scale(15.1284 15.1284)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7D5C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3C0AF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_10258_11880",
    x1: 13.9998,
    y1: 108,
    x2: 31.9998,
    y2: 108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3C0AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5645,
    stopColor: "#E7D5C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3C0AF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_10258_11880",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(61.5024 95.6632) scale(15.1284 15.1284)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7D5C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3C0AF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_10258_11880",
    x1: 52,
    y1: 108,
    x2: 70.9999,
    y2: 108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3C0AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5645,
    stopColor: "#E7D5C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3C0AF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_10258_11880",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(99.7478 95.6632) scale(15.1284 15.1284)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7D5C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3C0AF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_10258_11880",
    x1: 91.0001,
    y1: 108,
    x2: 109,
    y2: 108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3C0AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5645,
    stopColor: "#E7D5C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3C0AF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_10258_11880",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(137.993 95.6632) scale(15.1284 15.1284)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7D5C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3C0AF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_10258_11880",
    x1: 129,
    y1: 108,
    x2: 147,
    y2: 108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3C0AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5645,
    stopColor: "#E7D5C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3C0AF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_10258_11880",
    x1: 37.0083,
    y1: 73.6295,
    x2: 37.0083,
    y2: 81.2178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCB49C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6D6C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_10258_11880",
    x1: 124.242,
    y1: 73.6296,
    x2: 124.242,
    y2: 81.2178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCB49C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6D6C5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEggBox6Eggs);
export default __webpack_public_path__ + "static/media/egg_box_6_eggs.d738297f51c0bd393dacdc7feb8472ee.svg";
export { ForwardRef as ReactComponent };